import * as angular from "angular";
import {apsCommands} from "../../shared/dto/aps.commands";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import {DowntimeReason, DowntimeType} from "../../models/downtime";
import {Endpoints} from "../../shared/config/constant.module";
import HttpServiceName, {HttpService} from "../http/http.service";
import * as _ from "lodash";

let requires = [HttpServiceName];

export interface DowntimeService {
  getDowntimeTypesAndReasons: () => angular.IPromise<DowntimeTypesAndReasons>;
  addDowntime: (downtime: apsCommands.AddDowntimeBatch) => angular.IPromise<any>;
  saveDowntime: (downtime: apsCommands.AddDowntimeDurationOrComment) => angular.IPromise<any>;
  getOpenDowntimes: (shopId: string) => angular.IPromise<apsViewModels.DowntimeActivity[]>;
  deleteDowntime: (command: apsCommands.DeleteDowntime) => angular.IPromise<any>;
}

export interface DowntimeTypesAndReasons {
  downtimeReasons: DowntimeReason[];
  downtimeTypes: DowntimeType[];
}

export default angular.module('aps.services.downtimes', requires)
  .service('downtimeService', function(httpService: HttpService): DowntimeService {

    function getDowntimeTypesAndReasons(): angular.IPromise<DowntimeTypesAndReasons> {
      return httpService.get<apsViewModels.DowntimeReasonSelection[]>(Endpoints.DOWNTIME_TYPES)
      .then<DowntimeTypesAndReasons>(
      function(data) {
        let downtimeTypes = [];
        let downtimeReasons = [];
        _.forEach(data, function(viewModel) {
          downtimeReasons.push(new DowntimeReason(
            viewModel, downtimeTypes));
        });
        return {
          downtimeTypes: downtimeTypes,
          downtimeReasons: downtimeReasons
        };
      });
    }

    function addDowntime(downtime: apsCommands.AddDowntimeBatch) {
      return httpService.post(Endpoints.DOWNTIME, downtime);
    }

    function saveDowntime(downtime: apsCommands.AddDowntimeDurationOrComment) {
      return httpService.put(Endpoints.DOWNTIME, downtime);
    }

    function getOpenDowntimes(shopId: string) {
      let url = Endpoints.SHOP_DOWNTIMES.replace('{0}', shopId);
      return httpService.get<apsViewModels.DowntimeActivity[]>(url);
    }

    function deleteDowntime(command: apsCommands.DeleteDowntime) {
      return httpService.delete(Endpoints.DOWNTIME + '/' + command.id);
    }

    return {
      getDowntimeTypesAndReasons: getDowntimeTypesAndReasons,
      addDowntime: addDowntime,
      saveDowntime: saveDowntime,
      getOpenDowntimes: getOpenDowntimes,
      deleteDowntime: deleteDowntime
    };
  }).name;


// WEBPACK FOOTER //
// ./src/app/services/downtimes/downtime.service.ts